import { defineComponent as _defineComponent } from 'vue'
import { useEventPayoutInfoQuery, useTriggerEventPayoutMutation } from '@/enitites/event/api/queries'
import { mdiChevronDown, mdiChevronUp } from '@mdi/js'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventPayoutTrigger',
  props: {
    eventId: null
  },
  setup(__props: any) {

const props = __props as {
  eventId: number
};



const { data: payoutInfo } = useEventPayoutInfoQuery(props.eventId)
const { mutate, isPending } = useTriggerEventPayoutMutation()

const isExpanded = ref(false)

const formattedPayoutDate = (date: string) => {
  const d = new Date(date)
  const mm = String(d.getMonth() + 1).padStart(2, '0')
  const dd = String(d.getDate()).padStart(2, '0')
  const yy = String(d.getFullYear()).slice(-2)
  return `${mm}.${dd}.${yy}`
}

const triggerPayout = () => {
  mutate(props.eventId)
}

return { __sfc: true,props, payoutInfo, mutate, isPending, isExpanded, formattedPayoutDate, triggerPayout, mdiChevronDown, mdiChevronUp }
}

})